import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Interpreter from './Interpreter';
import Documentation from './Documentation';
import LegacyDocs from "./LegacyDocs";
import Documentation_v1 from "./legacy_docs/v1";
import './App.css';

function App() {
  return (
      <Router>
        <div className="app-container">
          <header className="app-header">
            <nav className="nav">
              <Link to="/" className="nav-link">Interpreter</Link>
              <Link to="/documentation" className="nav-link">Documentation</Link>
            </nav>
          </header>
          <main className="app-main">
            <Routes>
              <Route path="/" element={<Interpreter />} />
              <Route path="/documentation" element={<Documentation />} />
              <Route path="/legacy" element={<LegacyDocs />} />
              <Route path="/legacy-docs/v1" element={<Documentation_v1 />} />
            </Routes>
          </main>
        </div>
      </Router>
  );
}

export default App;
